import client from 'providers/fetchClient'

export const getImages = params => client.get('/image-catalog', { params })
